export const userAgent = navigator.userAgent;
// https://whereby.helpscoutdocs.com/article/415-supported-devices#mobile Whereby Supported Versions
// if this changes make sure to change BrowserSupport.tsx as well
const WHEREBY_SAFARI_IOS_VERSION = 13.1;
const WHEREBY_CHROME_IOS_VERSION = 14.5;

/**
 * Check for 'Mobi' as recommended by MDN webdocs
 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#mobile_tablet_or_desktop
 */

export function isMobile() {
  return !!userAgent && userAgent.indexOf('Mobi') !== -1;
}

// Source: https://stackoverflow.com/questions/8348139/detect-ios-version-less-than-5-with-javascript/47946090#47946090
export function checkIOSVersion(version) {
  if (/(iPhone|iPod|iPad)/i.test(userAgent)) {
    let iOSVersion = parseFloat(
      userAgent
        .match(/OS [\d_]+/i)[0]
        .substr(3)
        .split('_')
        .map(n => parseInt(n))
        .join('.'),
    );

    return iOSVersion >= version;
  }
  return false;
}

export function isSafari(version) {
  let versionCheck = true;
  if (!!version) {
    versionCheck = checkIOSVersion(version); // safari and iOS share same version
  }

  /**
   * check contains Safari and does not contain Chrome or Chromium:
   * https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#which_part_of_the_user_agent_contains_the_information_you_are_looking_for
   */
  return (
    !!userAgent &&
    userAgent.indexOf('Safari') !== -1 &&
    userAgent.indexOf('Chrome') === -1 &&
    userAgent.indexOf('CriOS') === -1 &&
    userAgent.indexOf('Chromium') === -1 &&
    versionCheck
  );
}

export function isChromeIOS(version) {
  let versionCheck = true;
  if (!!version) {
    versionCheck = checkIOSVersion(version);
  }

  /**
   * Check for Chrome/Crios and not Chromium:
   * https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#which_part_of_the_user_agent_contains_the_information_you_are_looking_for
   *
   * CriOS is what Chrome is on iOS
   * https://developer.chrome.com/docs/multidevice/user-agent/#chrome-for-ios
   */
  return (
    !!userAgent &&
    (userAgent.indexOf('CriOS') !== -1 || userAgent.indexOf('Chrome') !== -1) &&
    userAgent.indexOf('Chromium' === -1) &&
    versionCheck
  );
}

export function isOSX() {
  return !!userAgent && userAgent.indexOf('OS X') !== -1;
}

export function isIOS() {
  // if mobile and OSX then really we are dealing with IOS
  return !!isMobile() && !!isOSX();
}

/**
 * supports non mobile and sarari 11+ on ios
 * @TODO other broswers may in fact support WebRTC, enable all browsers that support webRTC
 */
export function wherebyMobileSupport() {
  let supported = !isMobile();

  // Whereby has limitations on what versions they support on IOS for these browsers.
  if (!!isIOS()) {
    supported =
      !!isSafari(WHEREBY_SAFARI_IOS_VERSION) ||
      !!isChromeIOS(WHEREBY_CHROME_IOS_VERSION);
  } else {
    supported = true;
  }
  return supported;
}
